import { callApi, getAlreadyBookedDinings } from '../../utils';
import { setBookedDinings } from './bookedEvents';
import {
  REQUEST_AVAILABLE_ADDONS,
  RECEIVE_AVAILABLE_ADDONS,
  SET_AVAILABLE_ADDONS_FAILURE,
  CLEAR_AVAILABLE_ADDONS_ERROR_MESSAGE,
  ON_SAVE_DINING,
} from '../constants/dinings';

const requestAvailableAddons = () => ({
  type: REQUEST_AVAILABLE_ADDONS,
});

const receiveAvailableAddons = (addons, bookedBreakfast, bookedDinner) => ({
  type: RECEIVE_AVAILABLE_ADDONS,
  addons,
  bookedBreakfast,
  bookedDinner,
});

const setAvailableAddonsFailure = error => ({
  type: SET_AVAILABLE_ADDONS_FAILURE,
  error,
});

export const clearAvailableAddonsErrorMessage = () => ({
  type: CLEAR_AVAILABLE_ADDONS_ERROR_MESSAGE,
});

export const getAvailableAddons = resId => async (dispatch, getState) => {
  dispatch(requestAvailableAddons());
  const { config } = getState();
  const {
    REACT_APP_BOOKING_PREFIX: bookingPrefix,
    REACT_APP_BOOKING_SUBSCRIPTION_KEY: bookingSubscriptionKey,
    REACT_APP_API_TIMEOUT_MS: timeout,
  } = config;
  try {
    const { data = {} } = await callApi(
      {
        method: 'get',
        url: `/common/account/booking/${resId}/addon`,
      },
      bookingPrefix,
      bookingSubscriptionKey,
      timeout,
    );
    const { Units: units = [] } = data.Data || {};
    const { bookedBreakfast, bookedDinner } = getAlreadyBookedDinings(units[0]);
    dispatch(receiveAvailableAddons(data.Data, bookedBreakfast, bookedDinner));
    dispatch(setBookedDinings({ bookedBreakfast, bookedDinner }));
  } catch (error) {
    if (process.env.NODE_ENV === 'development') console.error(error); // eslint-disable-line
    dispatch(setAvailableAddonsFailure(error));
  }
};

export const onSaveDining = () => ({
  type: ON_SAVE_DINING,
});
